import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.entries.js";
import 'whatwg-fetch';
import { apply, getPath, identity, propEquals, find } from '@anewgo/functions';
import * as siteplans from './siteplans.js';
import * as svg from './svg.js';
var cloudinaryPrefix = 'https://res.cloudinary.com/renderinghouse/image/upload';
var cloudinaryVideoPrefix = 'https://res.cloudinary.com/renderinghouse/video/upload';
var anewgoCloudinaryPrefix = 'https://res.cloudinary.com/renderinghouse/image/upload/anewgo';
var texturesPrefix = anewgoCloudinaryPrefix + "/library/textures";
var IPAD_PORTRAIT = "only screen and (min-device-width: 768px) and (max-device-width: 1024px)\nand (orientation: portrait)";
var IPAD_LANDSCAPE = "only screen  and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape)";

var formatColorSelection = function formatColorSelection(colorSelections) {
  if (!colorSelections) {
    return '';
  }

  var keys = Object.keys(colorSelections);

  if (keys.length === 0) {
    return '';
  }

  var mats = '';
  var sels = '';
  var pals = '';
  keys.forEach(function (key) {
    var matColor = colorSelections[key];
    mats += key + ',';
    pals += matColor.paletteId + ',';
    sels += matColor.id + ',';
  });
  mats = mats.slice(0, mats.length - 1);
  sels = sels.slice(0, sels.length - 1);
  pals = pals.slice(0, pals.length - 1);
  return "&mats=" + mats + "&pals=" + pals + "&sels=" + sels;
};

var updateRangeValues = function updateRangeValues(srcObj, attr, range) {
  if (srcObj[attr].min < range[0]) {
    range[0] = srcObj[attr].min;
  }

  if (srcObj[attr].max > range[1]) {
    range[1] = srcObj[attr].max;
  }
};

var updateAllRangeValues = function updateAllRangeValues(tgt, bedRange, bathRange, sqftRange, costRange) {
  updateRangeValues(tgt, 'bedRange', bedRange);
  updateRangeValues(tgt, 'bathRange', bathRange);
  updateRangeValues(tgt, 'sizeRange', sqftRange);
  updateRangeValues(tgt, 'costRange', costRange);
};

var computeExteriorUrl = function computeExteriorUrl(apiKey, client, colorMtd, communityName, directoryName, elevation, engineUrl, planName, selectedScheme, colorSelections, width, limitWd, mirror, apiVersion, descriptionPoints) {
  if (width === void 0) {
    width = 0;
  }

  if (limitWd === void 0) {
    limitWd = false;
  }

  if (mirror === void 0) {
    mirror = false;
  }

  if (apiVersion === void 0) {
    apiVersion = 1;
  }

  if (descriptionPoints === void 0) {
    descriptionPoints = null;
  }

  if (width <= 1) {
    return null;
  }

  var schemes = elevation.schemes,
      base = elevation.base;
  var formattedColorSelections = formatColorSelection(colorSelections); // Render with 900px width. If page is more wide than 900px, then render with 1800px width.

  var wd = width > 900 ? 1800 : 900;
  var prefix = limitWd ? getImagePrefix(directoryName, "c_scale,w_" + wd + (mirror ? ',a_hflip' : '')) : getImagePrefix(directoryName);
  var enginePrefix;

  if (apiVersion === 1) {
    enginePrefix = engineUrl + "/client/" + client + "/nbr/" + communityName + "/plan/" + planName;
  } else if (apiVersion === 2) {
    enginePrefix = engineUrl + "/client/" + client;
  }

  var url = prefix + "/" + base;
  var usingThumbUrl = false;

  if ((colorMtd === 'SCHEME' || colorMtd === 'HYBRID') && !selectedScheme || colorMtd === 'PALETTE' && formattedColorSelections === '') {
    if (elevation.thumb) {
      usingThumbUrl = true;
      url = getImagePrefix(directoryName, "c_scale,w_" + wd + (mirror ? ',a_hflip' : '')) + "/" + elevation.thumb;
    } else {
      url = enginePrefix + "/base?key=" + apiKey + "&elevId=" + elevation.id + (mirror ? '&mirror' : '');
    }
  } else if (colorMtd === 'SCHEME' && selectedScheme) {
    var scheme = apply(find(propEquals('id', selectedScheme.id)))(schemes) || selectedScheme;

    if (scheme) {
      if (apiVersion === 1) {
        url = enginePrefix + "/scheme/" + encodeURIComponent(scheme.name) + "?key=" + apiKey + "&elevId=" + elevation.id + (mirror ? '&mirror' : '');
      } else if (apiVersion === 2) {
        url = enginePrefix + "?elevId=" + elevation.id + "&mode=scheme&schemeId=" + encodeURIComponent(scheme.id);
      }
    }
  } else if (colorMtd === 'HYBRID' && selectedScheme) {
    var _scheme = apply(find(propEquals('id', selectedScheme.id)))(schemes) || selectedScheme;

    if (_scheme) {
      if (apiVersion === 1) {
        url = enginePrefix + "/hybrid/scheme/" + encodeURIComponent(_scheme.name) + "?key=" + apiKey + "&elevId=" + elevation.id + (mirror ? '&mirror' : '');
      } else if (apiVersion === 2) {
        url = enginePrefix + "?elevId=" + elevation.id + "&mode=hybrid&schemeId=" + encodeURIComponent(_scheme.id);
      }

      url += formattedColorSelections;
    }
  } else if (colorMtd === 'PALETTE') {
    if (apiVersion === 1) {
      url = enginePrefix + "/palette?key=" + apiKey + "&elevId=" + elevation.id + (mirror ? '&mirror' : '');
    } else if (apiVersion === 2) {
      url = enginePrefix + "?elevId=" + elevation.id + "&mode=palette";
    }

    url += formattedColorSelections;
  }

  if (limitWd && wd > 0 && !usingThumbUrl) {
    url += "&w=" + wd;
  }

  if (descriptionPoints) {
    url += "&points=" + descriptionPoints.map(function (point) {
      return "m" + point.materialId + "_" + point.pointNumber;
    });
  }

  return url;
};

var filterMaterialsByLayers = function filterMaterialsByLayers(materials, layers) {
  var result = [];
  layers.forEach(function (layer) {
    var material = materials.find(function (tgt) {
      return tgt.materialId === layer.materialId;
    });

    if (material) {
      result.push(Object.assign({}, material, {
        materialCategory: layer.materialCategory || material.materialCategory
      }));
    }
  }); // sort BODY, TRIM, ACCENT, ROOF, HARDSCAPE

  var order = {
    BODY: 1,
    ACCENT: 2,
    TRIM: 3,
    ROOF: 4,
    HARDSCAPE: 5
  };
  result.sort(function (a, b) {
    if (a.materialCategory === b.materialCategory) {
      return 0;
    }

    return order[a.materialCategory] - order[b.materialCategory];
  });
  return result;
};

var fetchImage = function fetchImage(url, abortSignal) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetch(url, {
                signal: abortSignal
              }).then(function (response) {
                if (response.status !== 200) {
                  console.log("failed to fetch " + url + " status:", response.status);
                }

                return response.blob();
              }).then(function (blob) {
                if (!blob.size) {
                  resolve(null);
                  return;
                }

                var img = new Image();

                img.onload = function () {
                  return resolve(img);
                };

                img.onerror = function (err) {
                  console.log("failed to fetch " + url + ":", err);
                  resolve(null);
                };

                img.src = URL.createObjectURL(blob);
              }).catch(function (ex) {
                console.log("failed to fetch " + url, ex);
                resolve(null);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var getAssetsPrefix = function getAssetsPrefix(directoryName, transformBit) {
  var prefix = getCloudPrefix(transformBit) + "/" + directoryName + "/assets";
  return prefix;
};

var MAX_PLANCARD_MEDIA_HT = 476;

var getInventoryImageUrl = function getInventoryImageUrl(inventory, elevation, directoryName, imageSrc, scaleImage) {
  var _inventory$elevation, _ref2, _inventory$elevation2;

  if (imageSrc === void 0) {
    imageSrc = null;
  }

  if (scaleImage === void 0) {
    scaleImage = true;
  }

  var img = !imageSrc && inventory && inventory.photos && inventory.photos.length > 0 ? inventory.photos[0].src : imageSrc;
  var shouldFlipImage = (inventory == null ? void 0 : inventory.garagePosition) && inventory.garagePosition !== (inventory == null ? void 0 : (_inventory$elevation = inventory.elevation) == null ? void 0 : _inventory$elevation.defaultGaragePosition);
  var isImageFromRendering = (_ref2 = img || (inventory == null ? void 0 : (_inventory$elevation2 = inventory.elevation) == null ? void 0 : _inventory$elevation2.thumb)) == null ? void 0 : _ref2.startsWith('exterior_image_'); // exterior_image_ means it's coming from the app-team. We don't want to flip an image uploaded by a builder themselves.
  // image cloudinary features

  var scale = scaleImage ? 'c_scale,h_' + MAX_PLANCARD_MEDIA_HT : '';
  var url; // Check if imageSrc is non-imported

  if (img !== null && !img.startsWith('imported_interiors_') && !img.startsWith('imported_exterior_')) {
    var imageFlip = shouldFlipImage && isImageFromRendering ? 'a_hflip' : '';
    var imageFeature = "" + scale + (imageFlip && scale ? ',' : '') + imageFlip;
    url = getAssetsPrefix(directoryName, imageFeature) + "/" + inventory.photoFolder + "/" + img;
  }

  if (img !== null && (img.startsWith('imported_interiors_') || img.startsWith('imported_exterior_'))) {
    var _inventory$plan, _inventory$plan2;

    var exteriorPrefix = getAssetsPrefix(directoryName) + "/photos/exterior/0_0_" + ((elevation == null ? void 0 : elevation.planId) || (inventory == null ? void 0 : (_inventory$plan = inventory.plan) == null ? void 0 : _inventory$plan.id)) + "_extPhotos";
    var interiorPrefix = getAssetsPrefix(directoryName) + "/photos/interior/0_0_" + ((elevation == null ? void 0 : elevation.planId) || (inventory == null ? void 0 : (_inventory$plan2 = inventory.plan) == null ? void 0 : _inventory$plan2.id)) + "_intPhotos";

    if (img.startsWith('imported_interiors_')) {
      var imgSrc = img.replace('imported_interiors_', '');

      if (interiorPrefix) {
        url = interiorPrefix + "/" + imgSrc;
      }
    }

    if (img.startsWith('imported_exterior_')) {
      var _imgSrc = img.replace('imported_exterior_', '');

      if (exteriorPrefix) {
        url = exteriorPrefix + "/" + _imgSrc;
      }
    }
  }

  if (!url && elevation && elevation.thumb) {
    // https://res.cloudinary.com/renderinghouse/image/upload/c_scale,h_476/app/demo/images/bennettG-lg_5bd7078f1d58f.jpg
    // In modern, we prefix image with for example `exterior_image_` as a flag that it came from rendering house, however for old images that we did before we were not doing that. See example above.
    // once we are inside this if statement passing the other barriers above, we are sure that the image came from the rendering house.
    // that is why we would now always flip
    var _imageFlip = shouldFlipImage ? 'a_hflip' : '';

    var _imageFeature = "" + scale + (_imageFlip && scale ? ',' : '') + _imageFlip;

    var prefix = getImagePrefix(directoryName, _imageFeature);
    url = prefix + "/" + elevation.thumb;
  }

  return url;
};

var getBaseElevations = function getBaseElevations(baseElevs) {
  if (!baseElevs) {
    return [];
  }

  if (baseElevs.length === 1) {
    return baseElevs;
  }

  var elevations = baseElevs.filter(function (tgt) {
    var mirrorElevationId = tgt.mirrorElevationId,
        mirrorRolePrimary = tgt.mirrorRolePrimary;

    if (!mirrorElevationId) {
      return true;
    } else if (mirrorRolePrimary) {
      return true;
    }

    return false;
  });
  return elevations;
};

var getCloudPrefix = function getCloudPrefix(transformBit) {
  // when we support other cloud prefixes... we need to revisit
  if (transformBit) {
    return cloudinaryPrefix + "/" + transformBit + "/app";
  }

  return cloudinaryPrefix + "/app";
};

var getImagePrefix = function getImagePrefix(directoryName, transformBit) {
  var prefix = getCloudPrefix(transformBit) + "/" + directoryName + "/images";
  return prefix;
};

var getPlanSpecs = function getPlanSpecs(plans, elevations) {
  if (plans === void 0) {
    plans = null;
  }

  if (elevations === void 0) {
    elevations = null;
  }

  var bedRange = [Number.MAX_VALUE, 0];
  var bathRange = [Number.MAX_VALUE, 0];
  var sqftRange = [Number.MAX_VALUE, 0];
  var costRange = [Number.MAX_VALUE, 0];

  if (getPath('length')(plans) > 0) {
    plans.forEach(function (plan) {
      return updateAllRangeValues(plan, bedRange, bathRange, sqftRange, costRange);
    });
  } else if (getPath('length')(elevations) > 0) {
    elevations.forEach(function (elev) {
      return updateAllRangeValues(elev, bedRange, bathRange, sqftRange, costRange);
    });
  }

  var getSpecs = function getSpecs(range, _ref3) {
    var label = _ref3.label,
        _ref3$transform = _ref3.transform,
        transform = _ref3$transform === void 0 ? identity : _ref3$transform;
    var min = range[0],
        max = range[1];

    var decorate = function decorate(text) {
      return label ? text + " " + label : text;
    };

    if (!min) {
      return null;
    } else if (min === max) {
      return decorate(transform(min));
    } else {
      return decorate(transform(min) + " - " + transform(max));
    }
  };

  return {
    bed: getSpecs(bedRange, {
      label: 'BR'
    }),
    bath: getSpecs(bathRange, {
      label: 'BA'
    }),
    size: getSpecs(sqftRange, {
      label: 'SQ FT'
    }),
    cost: getSpecs(costRange, {
      transform: function transform(cost) {
        return cost.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        }).split('.')[0];
      }
    })
  };
};

var getElevSpecs = function getElevSpecs(elevation) {
  if (elevation === void 0) {
    elevation = null;
  }

  var bedRange = [Number.MAX_VALUE, 0];
  var bathRange = [Number.MAX_VALUE, 0];
  var sqftRange = [Number.MAX_VALUE, 0];
  var costRange = [Number.MAX_VALUE, 0];

  if (elevation) {
    updateAllRangeValues(elevation, bedRange, bathRange, sqftRange, costRange);
  }

  var getSpecs = function getSpecs(elevation, field, range, _ref4) {
    var label = _ref4.label,
        _ref4$transform = _ref4.transform,
        transform = _ref4$transform === void 0 ? identity : _ref4$transform;
    var min = range[0],
        max = range[1];

    var decorate = function decorate(text) {
      return label ? text + " " + label : text;
    };

    if (min && max && min !== max) {
      // if we have a min and max that aren't the same, display range
      return decorate(transform(min) + " - " + transform(max));
    } else if (min) {
      // If min and max are not the same, use min if defined.
      return decorate(transform(min));
    } else if (elevation && elevation[field]) {
      // Otherwise, display field value
      return decorate(transform(elevation[field]));
    } else {
      return null;
    }
  };

  return {
    bed: getSpecs(elevation, 'bed', bedRange, {
      label: 'BR'
    }),
    bath: getSpecs(elevation, 'bath', bathRange, {
      label: 'BA'
    }),
    size: getSpecs(elevation, 'size', sqftRange, {
      label: 'SQ FT'
    }),
    cost: getSpecs(elevation, 'cost', costRange, {
      transform: function transform(cost) {
        return cost.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        }).split('.')[0];
      }
    })
  };
};

var getProductSpecs = function getProductSpecs(selection) {
  var _lot$inventory, _lot$inventory$exteri;

  var community = selection.community,
      $elevation = selection.elevation,
      lot = selection.lot,
      $inventory = selection.inventory,
      _selection$fpOptSelec = selection.fpOptSelections,
      fpOptSelections = _selection$fpOptSelec === void 0 ? {} : _selection$fpOptSelec,
      _selection$interiorDe = selection.interiorDesignSelections,
      interiorDesignSelections = _selection$interiorDe === void 0 ? [] : _selection$interiorDe,
      scheme = selection.scheme;
  var extConfigScheme = lot == null ? void 0 : (_lot$inventory = lot.inventory) == null ? void 0 : (_lot$inventory$exteri = _lot$inventory.exteriorConfiguration) == null ? void 0 : _lot$inventory$exteri.scheme;
  var tgtScheme = extConfigScheme || scheme;
  var inventory = $inventory || getPath('inventory')(lot);
  var elevation = $elevation || getPath('elevation')(inventory);
  var pricingEnabled = !community || community.pricing;
  var bedValue = getPath('beds')(inventory) || getPath('bed')(elevation);
  var bathValue = getPath('baths')(inventory) || getPath('bath')(elevation);
  var additionalSqft = 0;
  var additionalCost = getPath('premium')(lot) || 0;
  Object.values(fpOptSelections).forEach(function (floorplans) {
    floorplans.forEach(function (floorplan) {
      if (floorplan.size) {
        additionalSqft += floorplan.size;
      }

      if (floorplan.cost) {
        additionalCost += floorplan.cost;
      }

      if (floorplan.bed) {
        bedValue += floorplan.bed;
      }

      if (floorplan.bath) {
        bathValue += floorplan.bath;
      }
    });
  });
  interiorDesignSelections.length && interiorDesignSelections.forEach(function (intSelection) {
    // inventory homes create an issue with interior selections being an array with 1 entry of
    // undefined. Here we check to ensure there are valid interior selections
    if (intSelection) {
      Object.entries(intSelection).forEach(function (_ref5) {
        var k = _ref5[0],
            v = _ref5[1];

        if (k === 'interiorSelections' && v !== null) {
          var alreadyCountedPackages = [];
          Object.values(v).forEach(function (intSelections) {
            if (intSelections.sel && (intSelections.sel.alternateCost || intSelections.sel.cost)) {
              additionalCost += intSelections.sel.alternateCost || intSelections.sel.cost;
            }

            if (intSelections.sel && intSelections.sel.parentElementOptionCost) {
              additionalCost += intSelections.sel.parentElementOptionCost;
            }

            var isPackageAlreadyCounted = alreadyCountedPackages.find(function (pckg) {
              return pckg.id === intSelections.pac.id;
            });

            if (intSelections.pac && intSelections.pac.cost && !isPackageAlreadyCounted) {
              alreadyCountedPackages.push(intSelections.pac);
              additionalCost += intSelections.pac.cost;
            }
          });
        }
      });
    }
  });
  var baseSizeValue = getPath('sqft')(inventory) || getPath('size')(elevation);
  var sizeValue = !inventory && baseSizeValue ? baseSizeValue + additionalSqft : baseSizeValue;
  var baseCostValue = getPath('price')(inventory) || getPath('cost')(elevation);
  var costValue = !inventory && baseCostValue ? baseCostValue + additionalCost : baseCostValue; // in some cases there may be an incomplete inventory object that had been created
  // on the selected lot. In this case we check for inventory.price and calculate accordingly.

  costValue = inventory && !inventory.price ? costValue + additionalCost : costValue; // Add scheme cost

  costValue += (tgtScheme == null ? void 0 : tgtScheme.cost) || 0;

  var formatCost = function formatCost(value) {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    }).split('.')[0];
  };

  return {
    bed: bedValue && bedValue + " BR",
    bedValue: bedValue,
    bath: bathValue && bathValue + " BA",
    bathValue: bathValue,
    baseSize: baseSizeValue && baseSizeValue + " SQ FT",
    baseSizeValue: baseSizeValue,
    size: sizeValue && sizeValue + " SQ FT",
    sizeValue: sizeValue,
    baseCost: pricingEnabled ? apply(formatCost)(baseCostValue) : null,
    baseCostValue: pricingEnabled ? baseCostValue : null,
    cost: pricingEnabled ? apply(formatCost)(costValue) : null,
    costValue: pricingEnabled ? costValue : null
  };
}; // only useful when called from a browser


var isTouchDevice = function isTouchDevice() {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
    /* browser with either Touch Events of Pointer Events
         running on touch-capable device */
    return true;
  }

  return false;
};

export { IPAD_LANDSCAPE, IPAD_PORTRAIT, anewgoCloudinaryPrefix, cloudinaryPrefix, cloudinaryVideoPrefix, computeExteriorUrl, fetchImage, filterMaterialsByLayers, getAssetsPrefix, getBaseElevations, getCloudPrefix, getImagePrefix, getInventoryImageUrl, getElevSpecs, getPlanSpecs, getProductSpecs, isTouchDevice, texturesPrefix, siteplans, svg };